export const ERRORED_CLASSNAME = "im-errored-element";

/**
Using this is unnecessary for RHF forms, where errored inputs should be retrieved via the form instance.
**/
export const getErroredElements = () => {
    const erroredInputs = document.getElementsByClassName(ERRORED_CLASSNAME);
    return Array.from(erroredInputs);
};

/**
Using this is unnecessary for RHF forms, where scrolling to errors is handled by default as long as the field has a form-attached ref.
**/
export const scrollToFirstErroredElement = () => {
    const erroredElements = getErroredElements();
    if (erroredElements.length > 0) {
        erroredElements[0].scrollIntoView();
    }
};
